import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const ArrowRightFromLineIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.49854V0.498779C0 0.223327 0.223327 0 0.498779 0C0.774231 0 0.997559 0.223327 0.997559 0.498779V7.49854C0.997559 7.77399 0.774231 7.99731 0.498779 7.99731C0.223327 7.99731 0 7.77399 0 7.49854ZM6.14575 0.645996C6.34053 0.451222 6.65703 0.451222 6.85181 0.645996L9.85181 3.646C9.94526 3.73952 9.99756 3.8668 9.99756 3.99902C9.99749 4.1311 9.94513 4.25787 9.85181 4.35132L6.85181 7.35132C6.65703 7.54609 6.34053 7.54609 6.14575 7.35132C5.95126 7.15657 5.95118 6.8407 6.14575 6.646L8.29395 4.4978H2.49902C2.22365 4.4978 2.00038 4.27436 2.00024 3.99902C2.00024 3.72357 2.22357 3.50024 2.49902 3.50024H8.29468L6.14575 1.35132C5.95126 1.15657 5.95118 0.840699 6.14575 0.645996Z"
        fill={color}
      />
    </svg>
  ),
);

ArrowRightFromLineIcon.displayName = 'ArrowRightFromLineIcon';
